import React from 'react'

import WelcomeScreenComponent from '../components/welcome-screen/welcome-screen.jsx'

class WelcomeScreen extends React.Component {
  render() {
    return <WelcomeScreenComponent />
  }
}

export default WelcomeScreen
